import { useState, useContext, useEffect } from 'react';
import { LanguageContext } from '../language/LanguageContext';
import usePostMessage from '../hook/UsePostMessage';
import { signup_request_url } from '../Utilities/apiUrl';
import consts from '../Utilities/appConsts.json';
import useIframeParams from './useIframeParam';
import { Navigate, useNavigate } from 'react-router';
import useLoader from './useLoader';
import { useLicenseContext } from '../language/LicenseContext';


interface FormData {
  password: string;
  secondPassword: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  date: Date | null;
  mail: string;
}


const useRegisterForm = () => {
  const [formData, setFormData] = useState<FormData>({
    password: '',
    secondPassword: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    date: null,
    mail: '',
  });

  const [validationField, setValidationField] = useState<string[]>([]);
  const [checkedTerms, setCheckedTerms] = useState<boolean>(false);
  const [checkboxClicked, setCheckboxClicked] = useState<boolean>(false);
  const [checkedNewsletter, setCheckedNewsletter] = useState<boolean>(false);
  const [isShowHelperTextEmail, setIsShowHelperTextEmail] = useState(false);
  const [isShowHelperSecondPassword, setIsShowHelperTextSecondPassword] = useState(false);
  const [isShowHelperTextFirstName, setIsShowHelperTextFirstName] = useState(false);
  const [isShowHelperTextLastName, setIsShowHelperTextLastName] = useState(false);
  const [isShowHelperTextPassword, setIsShowHelperTextPassword] = useState(false);
  const [isShowHelperTextPhone, setIsShowHelperTextPhone] = useState(false);
  const [isAddBirthdayModal, setIsAddBirthdayModal] = useState(false);
  const [dateFieldChanged, setDateFieldChanged] = useState(false);
  const [flagForDateModal, setFlagForDateModal] = useState<boolean | null>(false);
  const { loading, showLoading, hideLoading, LoaderComponent } = useLoader();
  const { licenseTemplate, placeholders } = useLicenseContext();
  const navigate = useNavigate();
  const postMessage = usePostMessage();
  const { getTranslation } = useContext(LanguageContext);
  const channel = useIframeParams('channel') || "";
  const temptoken = useIframeParams('temptoken') || "";

  const handleOnClick = async () => {
    const isAnyFieldsEmpty = formDataEmpty();
    !checkedNewsletter && formData.date !== null && flagForDateModal && setIsAddBirthdayModal(true)
    if (checkedTerms && !isAnyFieldsEmpty && (!flagForDateModal || checkedNewsletter)) {
      if (validationField.length === 0) {
        const encodedPassword = encodeURIComponent(formData.password);
        const day = formData.date ? formData.date.getDate() : '';
        const month = formData.date ? formData.date.getMonth() + 1 : '';
        const year = formData.date ? formData.date.getFullYear() : '';
        showLoading();
        const data = await fetch(
          `${signup_request_url}&firstname=${formData.firstName}&lastname=${formData.lastName}&email=${formData.mail}&password=${encodedPassword}&channel=${channel}&phone=${formData.phoneNumber}&day=${day}&month=${month}&year=${year}&terms=${checkedTerms}&newsletter=${checkedNewsletter}`
        );

        let response = await data.json();
        if (!response.isValid) {
          setIsShowHelperTextEmail(true);
        }
        if(response.errorCode == 528){
          navigate(`/processregister?channel=${channel}&temptoken=${temptoken}`);
        }
        else{
          postMessage(response.payLoad); 
        }
      }
      else {

      }
    } else {
      setCheckboxClicked(true);
      if (formData.date !== null) {
        setFlagForDateModal(false);
      }
    }
    hideLoading();
  };


  useEffect(() => {
    if (formData.password != formData.secondPassword) {
      setIsShowHelperTextSecondPassword(true)
      const updatedValidationField = [...validationField, getTranslation(consts.PLEASE_TYPE_CONFIRM_PASSWORD)];
      setValidationField(updatedValidationField);
    }
  }, [formData.secondPassword])

  const handleChange = (checked: boolean, setState: React.Dispatch<React.SetStateAction<boolean>>, isTerms: boolean) => {
    setState(checked);
    isTerms && setCheckboxClicked(true)
  };

  const setIsError = (isError: boolean, name: string) => {
    if (isError) {
      const updatedValidationField = [...validationField, name];
      setValidationField(updatedValidationField);
    } else {
      const validationFieldNew = validationField.filter((e) => e !== name);
      setValidationField(validationFieldNew);
    }
  };

  const handleChangeFormData = (name: any, value: any, setErrorState?: React.Dispatch<React.SetStateAction<boolean>>) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setErrorState && setErrorState(false);
    if (name === 'date') {
      if (value === null) {
        setFlagForDateModal(false);
        setDateFieldChanged(false);
      } else if (!dateFieldChanged) {
        setFlagForDateModal(true);
        setDateFieldChanged(true);
      }
    }
  };


  const formDataEmpty = () => {
    let isAnyFieldEmpty = false;
    for (const key in formData) {
      if (key !== 'date' && (formData as any)[key] == '') {
        switch (key) {
          case 'password':
            setIsShowHelperTextPassword(true)
            break;
          case 'secondPassword':
            setIsShowHelperTextSecondPassword(true)
            break;
          case 'firstName':
            setIsShowHelperTextFirstName(true)
            break;
          case 'lastName':
            setIsShowHelperTextLastName(true)
            break;
          case 'mail':
            setIsShowHelperTextEmail(true)
            break;
          case 'phoneNumber':
            setIsShowHelperTextPhone(true)
            break;
          default:
            break;
        }
        isAnyFieldEmpty = true;
      }
    }
    return isAnyFieldEmpty;
  };

  return {
    formData,
    handleChangeFormData,
    isShowHelperTextPassword,
    isShowHelperTextFirstName,
    isShowHelperTextLastName,
    isShowHelperTextPhone,
    setIsError,
    handleChange,
    checkedTerms,
    setCheckedTerms,
    setIsShowHelperTextEmail,
    isShowHelperTextEmail,
    checkedNewsletter,
    setCheckedNewsletter,
    checkboxClicked,
    handleOnClick,
    getTranslation,
    isShowHelperSecondPassword,
    setIsShowHelperTextSecondPassword,
    setIsShowHelperTextFirstName,
    setIsShowHelperTextLastName,
    setIsShowHelperTextPhone,
    setIsShowHelperTextPassword,
    setIsAddBirthdayModal,
    isAddBirthdayModal,
    loading,
    LoaderComponent,
    licenseTemplate,
    placeholders
  };
};

export default useRegisterForm;
